const blogArticle = [
    {
        "heading": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad, commodi!",
        "descriptionBlog": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque nesciunt laudantium dolore. Quae corporis odit, earum at reiciendis hic consectetur?"
    },
    {
        "heading": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad, commodi!",
        "descriptionBlog": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque nesciunt laudantium dolore. Quae corporis odit, earum at reiciendis hic consectetur?"
    },
    {
        "heading": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad, commodi!",
        "descriptionBlog": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque nesciunt laudantium dolore. Quae corporis odit, earum at reiciendis hic consectetur?"
    },
    {
        "heading": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad, commodi!",
        "descriptionBlog": "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloremque nesciunt laudantium dolore. Quae corporis odit, earum at reiciendis hic consectetur?"
    }
]

export default blogArticle;
